import Api from "./Api";

class VoteApi extends Api {
  static vote(type, slug, vote) {
    return this.get("vote/" + type + "/" + slug + "/" + vote)
  }

  static favorise(type, slug) {
    return this.get("favorite/" + type + "/" + slug);
  }

  static subscribeTo(type, slug) {
    return this.get("subscribe/" + type + "/" + slug);
  }

  static subscribed(type, slug) {
    return this.get("user/subscribed/" + type + "/" + slug);
  }
}

export default VoteApi;